import { EXERCISE_DEFAULTS } from "./exerciseDefaults"

export const purifyPanelData = (data: any) => {
    return data?.map((exercise: any) => {
      return {
        exercise: {
          id: exercise.procedureId,
          name: exercise.exerciseName,
          nameKey: exercise.nameKey,
          image: exercise.exerciseImg,
          videoUrl: exercise.videoUrl
        },
        set: exercise.set,
        repeat: exercise.repeat,
        tolerance: exercise.tolerance,
        restInterval: Math.round(exercise.restInterval / 3600) || Math.round(12 / exercise.set),
        days: !exercise.isEveryOtherDay ? exercise.days : [],
        isEveryOtherDay: exercise.isEveryOtherDay || false,
        everyOtherDayPeriod: exercise.everyOtherDayPeriod || 1,
      }
    })
  }

export const purifyData = (data: any) => {
    return data?.map((exercise: any) => {
      return {
        exercise: {
          id: exercise.id,
          name: exercise.name,
          nameKey: exercise.nameKey,
          image: exercise.imageUrl,
          videoUrl: exercise.videoUrl
        },
        set: EXERCISE_DEFAULTS.set,
        repeat: EXERCISE_DEFAULTS.repeat,
        tolerance: EXERCISE_DEFAULTS.tolerance,
        restInterval: Math.round(12 / EXERCISE_DEFAULTS.set),
        days: EXERCISE_DEFAULTS.days,
        isEveryOtherDay: false,
        everyOtherDayPeriod: 1,
      }
    })
  }